import { observable, computed, action, makeObservable } from "mobx";
import { SuburbModel } from "../models/SuburbModel";
import { VariantModel } from "../models/VariantModel";
import { ApiBasePath } from "../utils/ApiBasePath";
import * as Request from "superagent";
import CustomEvent from "custom-event";
import { HomePageVariant } from "../components/HomePage/models/HomePageModel";
import HomePageStore from "../components/HomePage/HomePageStore";
import ModelWalkStore from "./ModelWalkStore";
import { ReactElement } from "react";
import ReactDOMServer from "react-dom/server";
import { PopupModalModel } from "../models/PopupModalModel";
import {
  DEFAULT_FINANCE_FORM_INPUT,
  ensureLiveFinanceFormInputForWidget,
  readStoredFinanceFormInput,
} from "../../../common/services/finance-form-input";
const PARENT_SITE_SUBMIT_EVENT = "continue";
let globalWidget;

export class WeeklyRepayment {
  @observable comparisonRate: number = 0;
  @observable paymentValue: number = 0;
  constructor(comparisonRate: number, paymentValue: number) {
    makeObservable(this);
    this.comparisonRate = comparisonRate;
    this.paymentValue = paymentValue;
  }
}

export default class RepaymentStore {
  @observable modelWalkStore: ModelWalkStore;
  @observable homePageStore: HomePageStore;
  @observable variants: VariantModel[] = Array(20).fill(null);
  @observable paymentValues: number[] = Array(20).fill(null);
  @observable monthlyRepayments: string[] = Array(20).fill(null);
  @observable comparisonRates: number[] = Array(20).fill(null);
  @observable interestRates: number[] = Array(20).fill(null);
  @observable paymentFrequency: string = "Weekly";
  @observable loanTerm: number = 0;
  @observable residualValues: number[] = Array(20).fill(null);
  @observable isGfvError: boolean[] = Array(20).fill(false);
  @observable isDepositTooHighError: boolean[] = Array(20).fill(false);
  @observable isGeneralError: boolean[] = Array(20).fill(false);
  @observable errorMessage: string[] = Array(20).fill(null);
  @observable deposits: number[] = Array(20).fill(null);
  @observable isFinanceFormInputPersonalised: boolean = false;
  @observable financeProductId: string = "";
  @observable mileage: number[] = Array(20).fill(null);
  @observable isLoading: boolean[] = Array(20).fill(true);

  suburb: SuburbModel = {
    postcode: "2000",
    name: "Sydney",
    state: "New South Wales",
  };
  stateSelection: SuburbModel = {
    postcode: "2000",
    name: "Sydney",
    state: "NSW",
  };
  public constructor(modelWalkStore: ModelWalkStore);
  public constructor(homePageStore: HomePageStore, isHomePage: boolean);
  public constructor(...constructorParams: any[]) {
    makeObservable(this);
    if (constructorParams.length === 1) {
      this.modelWalkStore = constructorParams[0];
    } else if (constructorParams.length === 2) {
      this.homePageStore = constructorParams[0];
    }

    var savedCookie = localStorage.getItem("suburb");
    if (savedCookie) {
      this.stateSelection = JSON.parse(savedCookie);
    }

    window.addEventListener("priceUpdated", (e: any) => {
      this.updateWeeklyRepaymentsForSingleVariant(e.detail.variant);
    });
    window.addEventListener("locationSelected", (e: any) => {
      this.updateSuburb(e.detail.suburb);
      this.stateSelection = e.detail.suburb;
    });
    window.addEventListener(
      PARENT_SITE_SUBMIT_EVENT,
      this.updateWeeklyRepaymentsForAllVariants
    );
    window.addEventListener("closeModal", this.closeModal);
  }

  @action updateSuburb(suburb) {
    this.suburb = suburb;
  }

  showPostcodeOverlayActive(): void {
    const evt = new CustomEvent("selectLocation", { detail: {} });
    window.dispatchEvent(evt);
  }
  @action onServerError = (error, index) => {
    console.error(
      "An error occurred loading the finance simulation data. Code 010.",
      error
    );
    this.isGeneralError.splice(index, 1, true);
    this.errorMessage.splice(
      index,
      1,
      "Something went wrong with your request unfortunately. Please try again later."
    );
    this.isLoading.splice(index, 1, false);
    return;
  };

  @action updateFinanceDataOnSuccess = (ret, index) => {
    const response = ret.body;
    //handling GFV not available error
    if (
      this.financeProductId === "FIN_PROD_AUS_SUB_GFV" &&
      (response.finance.simulationInfo[0].result.type === "not_applicable" ||
        response.finance.simulationInfo[0].result.simulation.financeProduct !==
          "FIN_PROD_AUS_SUB_GFV")
    ) {
      this.isGfvError.splice(index, 1, true);
      this.errorMessage.splice(
        index,
        1,
        "Sorry, GFV isn’t yet available for this vehicle. Please check with your local participating Retailer or check back soon."
      );
      this.isLoading.splice(index, 1, false);
      return;
    }
    //handling deposit too high error
    if (response.finance.simulationInfo[0].result.type === "na") {
      this.isDepositTooHighError.splice(index, 1, true);
      this.errorMessage.splice(
        index,
        1,
        "Based on your deposit, the loan amount on this vehicle would be too low. Please lower your deposit to see a repayment."
      );
      this.isLoading.splice(index, 1, false);
      return;
    }
    //handling general error
    if (response.finance.simulationInfo[0].result.type === "error") {
      this.isGeneralError.splice(index, 1, true);
      this.errorMessage.splice(
        index,
        1,
        "Something went wrong with your request. Please try again later."
      );
      this.isLoading.splice(index, 1, false);
      return;
    }
    this.isGfvError.splice(
      index,
      1,
      this.financeProductId === "FIN_PROD_AUS_SUB_GFV" &&
        (this.residualValues[index] === undefined ||
          this.residualValues[index] === 0)
    );
    this.comparisonRates.splice(
      index,
      1,
      response.finance.simulationInfo[0].result.simulation.comparisonRate
    );
    this.interestRates.splice(
      index,
      1,
      response.finance.simulationInfo[0].result.simulation.interestRate
    );
    this.paymentValues.splice(
      index,
      1,
      response.finance.simulationInfo[0].result.simulation.paymentValue[0]
        .amount / 100
    );
    this.monthlyRepayments.splice(
      index,
      1,
      response.finance.simulationInfo[0].result.simulation.financePackageId ===
        "Weekly"
        ? this.getMonthlyAmountFromDisclaimers(
            response.finance.simulationInfo[0].disclaimers
          )
        : `${
            response.finance.simulationInfo[0].result.simulation.paymentValue[0]
              .amount / 100
          }`
    );
    this.paymentFrequency =
      response.finance.simulationInfo[0].result.simulation.financePackageId;
    this.deposits.splice(
      index,
      1,
      response.finance.simulationInfo[0].result.simulation.deposits[0].value /
        100
    );
    this.loanTerm =
      response.finance.simulationInfo[0].result.simulation.loanTermPeriod.value;
    this.residualValues.splice(
      index,
      1,
      response.finance.simulationInfo[0].result.simulation.residualValue == null
        ? 0
        : response.finance.simulationInfo[0].result.simulation.residualValue
            .amount / 100
    );
    this.mileage.splice(
      index,
      1,
      response.finance.simulationInfo[0].result.simulation.mileage
    );
    //this.setLoading(false);
    this.isLoading.splice(index, 1, false);

    const eventObj = {
      detail: response.finance.simulationInfo[0].result.simulation,
    };
    eventObj.detail.isFinanceFormInputPersonalised =
      this.isFinanceFormInputPersonalised;

    window.dispatchEvent(new CustomEvent("repaymentInfoUpdated", eventObj));
  };

  @action initialiseIfVariantsChanged = () => {
    let isChanged: boolean = false;
    if (this.homePageStore) {
      this.homePageStore.homePageContent.response.discoverAndBuild[
        this.homePageStore.selectedTab
      ].map((item: HomePageVariant, index) => {
        if (
          !this.variants[index] ||
          this.variants[index].pimIdentifier !== item.pimIdentifier
        ) {
          isChanged = true;
        }
      });
    } else if (this.modelWalkStore) {
      this.modelWalkStore.variants.map((item: VariantModel, index) => {
        if (
          !this.variants[index] ||
          this.variants[index].pimIdentifier !== item.pimIdentifier
        ) {
          isChanged = true;
        }
      });
    }
    if (!isChanged) {
      return;
    }
    let variants: any[] = [];
    if (this.homePageStore) {
      this.homePageStore.homePageContent.response.discoverAndBuild[
        this.homePageStore.selectedTab
      ].map((item: HomePageVariant) => {
        const newItem = { pimIdentifier: item.pimIdentifier, rdp: item.price };
        variants.push(newItem);
        this.variants = variants;
      });
    } else if (this.modelWalkStore) {
      this.modelWalkStore.variants.map((item: VariantModel) => {
        const newItem = { pimIdentifier: item.pimIdentifier, rdp: item.rdp };
        variants.push(newItem);
        this.variants = variants;
      });
    }
    if (this.variants == null) {
      return;
    }
    this.initialiseArrays();
  };

  @action updateWeeklyRepaymentsForAllVariants = (event) => {
    this.initialiseIfVariantsChanged();
    this.variants.map((variant: VariantModel, index) => {
      this.isLoading.splice(index, 1, true);
      this.getFinanceSimulationByVariant(
        variant,
        event,
        index,
        this.updateFinanceDataOnSuccess,
        (error) => {
          this.onServerError(error, index);
        }
      );
    });
  };

  @action updateWeeklyRepaymentsForSingleVariant = (variant) => {
    this.initialiseIfVariantsChanged();
    var index = this.variants.findIndex(
      (x) => x != null && x.pimIdentifier === variant.pimIdentifier
    );
    if (index < 0) {
      return;
    }
    this.isLoading.splice(index, 1, true);
    this.getFinanceSimulationByVariant(
      variant,
      null,
      index,
      this.updateFinanceDataOnSuccess,
      (error) => {
        this.onServerError(error, index);
      }
    );
  };

  @computed get paymentFrequencyString() {
    if (this.paymentFrequency == "Weekly") {
      return "week";
    } else if (this.paymentFrequency == "Fortnightly") {
      return "fortnight";
    } else if (this.paymentFrequency == "Monthly") {
      return "month";
    } else {
      return "week";
    }
  }
  @action initialiseArrays() {
    if (this.comparisonRates.length > 0) {
      return;
    }
    this.comparisonRates = [];
    this.interestRates = [];
    this.paymentValues = [];
    this.deposits = [];
    for (let i = 0; i < this.variants.length; i++) {
      this.interestRates.push(0);
      this.comparisonRates.push(0);
      this.paymentValues.push(0);
      this.deposits.push(0);
    }
  }

  @action getFinanceSimulationByVariant(
    variant: VariantModel,
    financeFormInputEvent: any,
    index: number,
    successCallback: (response: Request.Response, index: number) => any,
    failureCallback: (error: any) => any
  ) {
    const url = `${ApiBasePath.finance}`;
    let financeFormInput = null;
    if (financeFormInputEvent) {
      this.isFinanceFormInputPersonalised = true;
      financeFormInput = financeFormInputEvent.detail.event;
      // localStorage.setItem("au_sub-dis_finance_form_input", JSON.stringify(financeFormInput))
      //financeFormInput.financeProductId = "FIN_PROD_AUS_SUB_LOAN";
    } else {
      financeFormInput = readStoredFinanceFormInput();
      this.isFinanceFormInputPersonalised = financeFormInput !== null;
    }
    if (financeFormInput === null) {
      financeFormInput = { ...DEFAULT_FINANCE_FORM_INPUT };
    }
    this.financeProductId = financeFormInput.financeProductId;
    const variables = {
      codes: [variant.pimIdentifier],
      financeFormInput: financeFormInput,
      postCode: this.getSavedPostcode(),
    };

    Request.post(url)
      .set("Content-Type", "application/json")
      .send(JSON.stringify(variables))
      .then((ret) => {
        successCallback(ret, index);
      }, failureCallback);
  }

  showFinanceSettingsModal(pimIdentifier: string): void {
    document.getElementById("modal").style.visibility = "visible";
    this.setupWidget(pimIdentifier);
  }
  closeModal() {
    document.getElementById("modal").style.visibility = "hidden";
    globalWidget.destroy();
  }
  setupWidget(pimIdentifier: string) {
    const DXP_SUBMIT_EVENT = "continue";
    if (window["FC"] == null) {
      return;
    }

    ensureLiveFinanceFormInputForWidget();

    const FCLibrary = window["FC"].InchcapeFinance;

    let postcode = this.getSavedPostcode();

    const config = {
      containerId: "repayment_calculator_root",
      car: {
        code: pimIdentifier,
        featureCodes: {
          values: [],
        },
      },
      version: "new",
      viewMode: "full",
      postcode: postcode,
      dimensions: {
        brand: "sub-dis",
        country: "au",
        language: "en-au",
        region: "au",
      },
      externalSite: true,
    };

    FCLibrary.createWidget(config)
      .then(function (widget) {
        globalWidget = widget;
        widget.on(DXP_SUBMIT_EVENT, (event) => {
          window.dispatchEvent(
            new CustomEvent(PARENT_SITE_SUBMIT_EVENT, {
              detail: { event: event },
            })
          );

          window.dispatchEvent(
            new CustomEvent("updateRepaymentInfo", {
              detail: { ...event },
            })
          );

          document.getElementById("modal").style.visibility = "hidden";
          globalWidget.destroy();
        });
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  getSavedPostcode(): string {
    var savedCookie = localStorage.getItem("suburb");
    if (savedCookie) {
      this.stateSelection = JSON.parse(savedCookie);
    }

    if (!this.stateSelection.postcode) {
      this.stateSelection.postcode = "2000";
    }
    let postcode = this.stateSelection.postcode.toString();

    if (postcode.length === 3) {
      postcode = "0".concat(postcode);
    }

    return postcode;
  }

  getMonthlyAmountFromDisclaimers(disclaimers): string {
    const repaymentDisclaimer = disclaimers.find(
      (x) => x.purpose === "Repayment"
    );
    if (repaymentDisclaimer) {
      const inputString = repaymentDisclaimer.value;
      // Regular expression pattern to match dollar values
      const dollarPattern = /repayment is \$\d{1,3}(,\d{3})*(\.\d{2})?/;

      // Find all dollar values in the string
      const dollarValues = inputString.match(dollarPattern);
      const dollarStr = dollarValues[0].substring(13); // discarding the $ sign as well
      return dollarStr;
    }
    return "";
  }

  showDisclaimer(element: ReactElement): void {
    const modalContent = ReactDOMServer.renderToStaticMarkup(element);
    const content: PopupModalModel = {
      title: "",
      text: modalContent,
    };
    const evt = new CustomEvent("showPopupModal", { detail: { content } });
    window.dispatchEvent(evt);
  }
}
